import { Loader, Skeleton } from '@mantine/core'
import { translate } from 'i18n/i18n'

export const NDVISkeleton = () => (
  <div>
    <div css={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
      <h3 css={{ margin: 0 }}>{translate.phrases.banyanApp('Crop Vegetation & Uniformity (NDVI)')}</h3>
      <Loader size="sm" color="blue" />
    </div>
    <Skeleton height={300} radius="sm" animate />
    <Skeleton height={60} mt={20} radius="sm" animate />
  </div>
)
